import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const login = () => {
    const state = crypto.randomBytes(16).toString('hex');
    localStorage.setItem(' oauth_state', state);
    window.location.href = `${API_URL}/api/auth/discord?state=${state}`;
  };

  const logout = () => {
    setLoading(true);
    try {
        fetch(`${API_URL}/api/auth/logout`, {
            method: 'POST',
            credentials: 'include'
        });
    } catch (err) {
        console.error('Logout failed:', err);
    } finally {
        localStorage.removeItem('auth_token');
        setUser(null);
        setLoading(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext); 